import React from "react";
import CommissionsStatusHistory from "../reports/commissions/CommissionsStatusHistory";
import { fetchProviderInsightsApplicationStatusHistory } from "./providerInsightsApi";

export default function ProviderInsightsApplicationStatus({
  applicationId,
  currentStatus,
  statusHistory = [],
}) {
  const history = statusHistory ?? [];

  return (
    <CommissionsStatusHistory
      stackTop
      countBadgeVariant="corner"
      statusHistory={history}
      fallbackTitle={currentStatus?.title ?? "—"}
      fallbackAt={
        currentStatus?.status_change_at ??
        currentStatus?.status_change_date ??
        currentStatus?.changed_at ??
        null
      }
      onBeforeOpen={
        applicationId
          ? async () => {
              const payload = await fetchProviderInsightsApplicationStatusHistory(
                applicationId,
              );
              return payload?.status_history ?? payload?.statusHistory ?? [];
            }
          : undefined
      }
    />
  );
}
